import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { ACTION_BLUE } from '../../theme/theme';

interface ContractInfoModalProps {
  open: boolean;
  onClose: () => void;
}

const ContractInfoModal: React.FC<ContractInfoModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="contract-info-modal"
      aria-describedby="modal-with-contract-information"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', sm: '80%', md: '600px' },
          maxWidth: '600px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          direction: 'rtl',
        }}
      >
        <Typography
          id="contract-info-modal"
          variant="h6"
          component="h2"
          sx={{
            textAlign: 'right',
            color: '#25282E',
            fontSize: 18,
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 700,
            mb: 3,
            pb: 2,
            borderBottom: '1px solid #E5E5E8',
          }}
        >
          توضیحات قرارداد
        </Typography>

        <Typography
          sx={{
            textAlign: 'right',
            color: '#60646E',
            fontSize: 14,
            fontFamily: 'IRANYekanXFaNum',
            lineHeight: '24px',
            mb: 3,
            p: 2,
            backgroundColor: '#F8F9FA',
            borderRadius: 1,
            border: '1px solid #E9ECEF',
          }}
        >
          در صورت ثبت هویت حقوقی؛ لطفا از سربرگ و مهر شرکت استفاده شود
        </Typography>

        <Typography
          sx={{
            textAlign: 'right',
            color: '#60646E',
            fontSize: 14,
            fontFamily: 'IRANYekanXFaNum',
            lineHeight: '24px',
            mb: 3,
            p: 2,
            backgroundColor: '#FFF3CD',
            borderRadius: 1,
            border: '1px solid #FFEAA7',
            fontStyle: 'italic',
          }}
        >
          اینجانب .... با شماره ملی .... به عنوان معرف مجموعه ی .... اعلام
          آمادگی کرده و زین پس مسٔولیت امور مربوط به این اپلیکیشن را عهده دار
          خواهم بود.
        </Typography>

        <Typography
          sx={{
            textAlign: 'center',
            color: '#60646E',
            fontSize: 14,
            fontFamily: 'IRANYekanXFaNum',
            lineHeight: '24px',
            mb: 3,
            p: 2,
            backgroundColor: '#E8F5E8',
            borderRadius: 1,
            border: '1px solid #C8E6C9',
            fontWeight: 600,
          }}
        >
          تاریخ و امضا
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: ACTION_BLUE,
              color: '#FFFFFF',
              fontFamily: 'IRANYekanXFaNum',
              fontSize: 14,
              fontWeight: 500,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#1565C0',
              },
            }}
          >
            بستن
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ContractInfoModal;
